import React, { useState } from 'react'
import { Search, SearchIcon } from './Search'
import MobileNavigation from './MobileNavigation'

import './Header.css'

const Header = () => {
  const [searchOpen, setSearchOpen] = useState(false)
  const [mobileNavOpen, setMobileNavOpen] = useState(false)

  return (
    <div
      className="header"
      style={{
        position: "fixed",
        top: 0,
        right: 0,
        left: 0,
        zIndex: 120,
      }}
    >
      <TopBar searchOpen={searchOpen} setSearchOpen={setSearchOpen} />
      <NavBar />
      <MobileNavigation
        open={mobileNavOpen}
        onClose={e => setMobileNavOpen(false)}
        onOpen={e => setMobileNavOpen(true)}
      />
    </div>
  )
}

const NavBar = props => {
  return (
    <div className="nav-bar" dangerouslySetInnerHTML={createNavMarkup()}>
    </div>
  )
}

const TopBar = props => {
  return (
    <div className="top-bar">
      <Search
        open={props.searchOpen}
        onClose={e => props.setSearchOpen(false)}
      />
      <div className="contact-bar">
        <div className="contact-center">
          <div>
            <span>CALL US TODAY</span>
            <a
              className="phone-number"
              href="tel:866-220-8735"
            >
              866.220.8735
            </a>
          </div>
          <div style={{display: "flex", alignItems: "center"}}>
            <SearchIcon onClick={e => props.setSearchOpen(true)} />
            <a
              className="contact-btn"
              href="https://www.onepointesolutions.com/contact/"
            >
              Contact
            </a>
          </div>
        </div>
      </div>
      <div className="header-menu">
      </div>
    </div>
  )
}

export default Header

const createNavMarkup = () => {
  return {__html: htmlNavString}
}

const htmlNavString = `
<style>
  /* cyrillic-ext */
@font-face {
  font-family: 'PT Sans';
  font-style: normal;
  font-weight: 400;
  src: local('PT Sans'), local('PTSans-Regular'), url(https://fonts.gstatic.com/s/ptsans/v11/jizaRExUiTo99u79D0-ExdGM.woff2) format('woff2');
  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
}
/* cyrillic */
@font-face {
  font-family: 'PT Sans';
  font-style: normal;
  font-weight: 400;
  src: local('PT Sans'), local('PTSans-Regular'), url(https://fonts.gstatic.com/s/ptsans/v11/jizaRExUiTo99u79D0aExdGM.woff2) format('woff2');
  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}
/* latin-ext */
@font-face {
  font-family: 'PT Sans';
  font-style: normal;
  font-weight: 400;
  src: local('PT Sans'), local('PTSans-Regular'), url(https://fonts.gstatic.com/s/ptsans/v11/jizaRExUiTo99u79D0yExdGM.woff2) format('woff2');
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'PT Sans';
  font-style: normal;
  font-weight: 400;
  src: local('PT Sans'), local('PTSans-Regular'), url(https://fonts.gstatic.com/s/ptsans/v11/jizaRExUiTo99u79D0KExQ.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}
/* cyrillic-ext */
@font-face {
  font-family: 'PT Sans';
  font-style: normal;
  font-weight: 700;
  src: local('PT Sans Bold'), local('PTSans-Bold'), url(https://fonts.gstatic.com/s/ptsans/v11/jizfRExUiTo99u79B_mh0OOtLQ0Z.woff2) format('woff2');
  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;
}
/* cyrillic */
@font-face {
  font-family: 'PT Sans';
  font-style: normal;
  font-weight: 700;
  src: local('PT Sans Bold'), local('PTSans-Bold'), url(https://fonts.gstatic.com/s/ptsans/v11/jizfRExUiTo99u79B_mh0OqtLQ0Z.woff2) format('woff2');
  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}
/* latin-ext */
@font-face {
  font-family: 'PT Sans';
  font-style: normal;
  font-weight: 700;
  src: local('PT Sans Bold'), local('PTSans-Bold'), url(https://fonts.gstatic.com/s/ptsans/v11/jizfRExUiTo99u79B_mh0OCtLQ0Z.woff2) format('woff2');
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
/* latin */
@font-face {
  font-family: 'PT Sans';
  font-style: normal;
  font-weight: 700;
  src: local('PT Sans Bold'), local('PTSans-Bold'), url(https://fonts.gstatic.com/s/ptsans/v11/jizfRExUiTo99u79B_mh0O6tLQ.woff2) format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

.menu-wrapper {
  max-height: 94px;
}
.menu-desktop {
  box-shadow: -2px 0 20px 0px #888888;
  height: 82px;
}
.background-white {
  background-color: #ffffff;
}
.container {
  max-width: 1300px;
  margin-right: auto;
  margin-left: auto;
}
@media (min-width: 768px) {
  .container {
    padding-left: 30px;
    padding-right: 30px;
  }
}
@media (min-width: 992px) {
  .container {
    width: auto;
  }
}
.menu-wrapper .header-wrapper {
  display: inline-flex;
  align-items: center;
  height: 100%;
}
.row {
  margin-left: -15px;
  margin-right: -15px;
}
@media (min-width: 1280px) {
  .col-lg-3 {
      width: 25%;
  }
}
@media (min-width: 1280px) {
  .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12 {
      float: left;
  }
}
.menu-wrapper .brand a, .menu-wrapper .brand img {
  width: 100%;
  object-fit: scale-down;
  height: 100%;
  display: block;
}
@media (min-width: 1280px) {
  .col-lg-9 {
      width: 75%;
  }
}
.container {
  height: 100%;
}
.menu-wrapper ul li {
  margin: 0;
  display: inline-block;
  position: relative;
  padding-right: 15px;
  padding-left: 15px;
}
/*
.sub-menu {
  margin-left: -15px;
}
*/

.menu-wrapper ul li a {
  display: flex;
  align-items: center;
  height: 80px;
  color: #212222;
  font-family: "PT Sans"!important;
  text-transform: none;
  line-height: 1.25em;
  font-weight: normal;
  padding: 0 0;
  font-size: 16px !important;
  text-align: center;
}
.menu-wrapper ul li .sub-menu {
  background: #1f76e2;
  transition: all .5s ease;
  display: none;
  position: absolute;
  width: max-content;
  top: 80px;
  padding: 0;
}
.menu-wrapper ul li .sub-menu li {
  display: block;
  text-align: left;
}
.menu-wrapper ul li {
  margin: 0;
  position: relative;
}
.menu-wrapper ul li .sub-menu li a {
    text-transform: capitalize !important;
    display: block;
    height: auto;
    width: 100%;
    color: #ffffff;
    padding: 8px 10px;
    text-align: left;
}
.col-xs-9, .col-lg-9 {
  height: 100%;
  position: relative;
  min-height: 1px;
  padding-left: 40px;
}

@media (min-width: 1280px) {
  .col-lg-3 {
      width: 25%;
  }
  .col-lg-9 {
      width: 75%;
  }
}

.menu-item-has-children:hover .sub-menu {
  display: block;
}
.menu-wrapper ul li#menu-item-21116 > ul.sub-menu > li {
    max-width: 20%;
}
.menu-wrapper ul li.mega-menu > ul.sub-menu > li {
    float: left;
    padding-right: 15px;
}
.menu-wrapper ul li .sub-menu li {
    display: block;
    text-align: left;
}
.menu-wrapper ul li.mega-menu > ul.sub-menu > li > ul.sub-menu {
    display: block;
    width: max-content!important;
    position: relative;
    top: 0;
}

.menu-item:hover {
  background: #1f76e2;
}

.menu-item:hover a {
  text-decoration: none;
  color: white;
}

.sub-menu a:hover {
  background: white;
  color: black!important;
}

.sub-menu-root {
  margin-left: -15px;
}
@media screen and (max-width: 1288px) {
  ul {
    margin-left: 0;
    margin-right: 0;
    padding: 0;
  }

  .menu-wrapper img {
    width: 50%;
    height: 50%;
  }

  .menu-wrapper ul li {
    padding-left: 5px;
    padding-right: 5px;
  }
  .col-xs-9, .col-lg-9 {
    padding: 0!important;
  }
}

@media screen and (max-width: 1000px) {
  .top-bar, .nav-bar {
    display: none;
  }

  .menu-mobile {
    width: calc(100% - 30px);
  }

  .mobile-phone {
    width: 30%;
  }
}

</style>

<div class="menu-wrapper menu-desktop background-white">
	<div class="container">
		<div class="row header-wrapper">
			<div class="col-xs-3 col-lg-3">
				<div class="brand">
					<a href="https://onepointesolutions.com" title="Go Home"><img src="https://www.onepointesolutions.com/wp-content/themes/onepointe-wordpress/img/onepointe-logo.png" alt="OnePointe Solutions Logo"></a>
				</div>
			</div>
			<div class="col-xs-9 col-lg-9">
				<nav class="main-menu">
                    <div class="menu-main-menu-container"><ul id="menu-main-menu-1" class="menu"><li id="menu-item-91" class="menu-item menu-item-type-post_type menu-item-object-page"><a href="https://www.onepointesolutions.com/gallery/"><span data-hover="Gallery">Gallery</span></a></li>
<li id="menu-item-81" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children"><a href="https://www.onepointesolutions.com/industrial/"><span data-hover="Commercial/Industrial">Commercial/Industrial</span></a>
<ul class="sub-menu sub-menu-root">
	<li id="menu-item-22282" class="menu-item menu-item-type-post_type menu-item-object-page"><a href="https://www.onepointesolutions.com/industrial/wood-plam-laboratory-casework/"><span data-hover="Plastic Laminate Cabinets">Plastic Laminate Cabinets</span></a></li>
	<li id="menu-item-20433" class="menu-item menu-item-type-post_type menu-item-object-page"><a href="https://www.onepointesolutions.com/industrial/custom-workbenches/"><span data-hover="Custom Workbenches">Custom Workbenches</span></a></li>
	<li id="menu-item-21369" class="menu-item menu-item-type-post_type menu-item-object-page"><a href="https://www.onepointesolutions.com/industrial/it-lan-workbench/"><span data-hover="IT/LAN Workbenches">IT/LAN Workbenches</span></a></li>
	<li id="menu-item-1707" class="menu-item menu-item-type-post_type menu-item-object-page"><a href="https://www.onepointesolutions.com/industrial/esd-workbenches/"><span data-hover="ESD Workbenches">ESD Workbenches</span></a></li>
	<li id="menu-item-20456" class="menu-item menu-item-type-post_type menu-item-object-page"><a href="https://www.onepointesolutions.com/industrial/packing-stations/"><span data-hover="Packing Stations">Packing Stations</span></a></li>
	<li id="menu-item-1709" class="menu-item menu-item-type-post_type menu-item-object-page"><a href="https://www.onepointesolutions.com/industrial/industry-storage/"><span data-hover="Industrial Storage">Industrial Storage</span></a></li>
	<li id="menu-item-21975" class="menu-item menu-item-type-post_type menu-item-object-page"><a href="https://www.onepointesolutions.com/industrial/custom-metal-work/"><span data-hover="Custom Metal Work">Custom Metal Work</span></a></li>
</ul>
</li>
<li id="menu-item-21116" class="mega-menu menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children"><a href="https://www.onepointesolutions.com/lab/"><span data-hover="Lab Furniture">Lab Furniture</span></a>
<ul class="sub-menu sub-menu-root">
	<li id="menu-item-20383" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children"><a href="https://www.onepointesolutions.com/lab/laboratory-tables/"><span data-hover="Lab Tables">Lab Tables</span></a>
	<ul class="sub-menu">
		<li id="menu-item-21097" class="menu-item menu-item-type-custom menu-item-object-custom"><a href="https://www.onepointesolutions.com/lab/laboratory-workbenches/"><span data-hover="Workbenches">Workbenches</span></a></li>
		<li id="menu-item-21095" class="menu-item menu-item-type-custom menu-item-object-custom"><a href="https://www.onepointesolutions.com/lab/laboratory-islands/"><span data-hover="Flex Systems &amp; Islands">Flex Systems &amp; Islands</span></a></li>
		<li id="menu-item-22522" class="menu-item menu-item-type-post_type menu-item-object-page"><a href="https://www.onepointesolutions.com/lab/laboratory-tables/balance-anti-vibration/"><span data-hover="Balance Tables">Balance Tables</span></a></li>
		<li id="menu-item-20431" class="menu-item menu-item-type-post_type menu-item-object-page"><a href="https://www.onepointesolutions.com/lab/laboratory-tables/mass-spec-bench/"><span data-hover="Mass Spec Benches">Mass Spec Benches</span></a></li>
		<li id="menu-item-21098" class="menu-item menu-item-type-custom menu-item-object-custom"><a href="https://www.onepointesolutions.com/lab/microscope-lab-tables/"><span data-hover="Microscope Tables">Microscope Tables</span></a></li>
		<li id="menu-item-21099" class="menu-item menu-item-type-custom menu-item-object-custom"><a href="https://www.onepointesolutions.com/lab/laboratory-tables/academic/"><span data-hover="Science Classroom Workstations">Science Classroom Workstations</span></a></li>
	</ul>
</li>
	<li id="menu-item-19055" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children"><a href="https://www.onepointesolutions.com/lab/laboratory-casework/"><span data-hover="Lab Casework">Lab Casework</span></a>
	<ul class="sub-menu sub-menu-root">
		<li id="menu-item-21101" class="menu-item menu-item-type-custom menu-item-object-custom"><a href="https://www.onepointesolutions.com/lab/metal-laboratory-cabinets/"><span data-hover="Metal Casework">Metal Casework</span></a></li>
		<li id="menu-item-21102" class="menu-item menu-item-type-custom menu-item-object-custom"><a href="https://www.onepointesolutions.com/lab/wood-plam-laboratory-casework/"><span data-hover="Plastic Laminate Casework">Plastic Laminate Casework</span></a></li>
		<li id="menu-item-22539" class="menu-item menu-item-type-post_type menu-item-object-page"><a href="https://www.onepointesolutions.com/lab/laboratory-casework/phenolic-resin-casework/"><span data-hover="Phenolic Resin Casework">Phenolic Resin Casework</span></a></li>
		<li id="menu-item-21103" class="menu-item menu-item-type-custom menu-item-object-custom"><a href="https://www.onepointesolutions.com/lab/stainless-steel-laboratory-furniture/"><span data-hover="Stainless Steel Casework">Stainless Steel Casework</span></a></li>
		<li id="menu-item-21516" class="menu-item menu-item-type-post_type menu-item-object-page"><a href="https://www.onepointesolutions.com/lab/laboratory-casework/anti-microbial-lab-cabinets/"><span data-hover="Anti-Microbial Casework">Anti-Microbial Casework</span></a></li>
		<li id="menu-item-22532" class="menu-item menu-item-type-post_type menu-item-object-page"><a href="https://www.onepointesolutions.com/lab/laboratory-casework/stainless-steel-medical-cabinets/"><span data-hover="Stainless Steel Medical Casework">Stainless Steel Medical Casework</span></a></li>
		<li id="menu-item-22089" class="menu-item menu-item-type-post_type menu-item-object-post"><a href="https://www.onepointesolutions.com/custom-veterinary-cabinetry/"><span data-hover="Veterinary Casework">Veterinary Casework</span></a></li>
	</ul>
</li>
	<li id="menu-item-22533" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children"><a href="https://www.onepointesolutions.com/lab/laboratory-countertops/"><span data-hover="Laboratory Countertops">Laboratory Countertops</span></a>
	<ul class="sub-menu sub-menu-root">
		<li id="menu-item-21130" class="menu-item menu-item-type-post_type menu-item-object-page"><a href="https://www.onepointesolutions.com/lab/laboratory-countertops/epoxy-resin/"><span data-hover="Epoxy Resin">Epoxy Resin</span></a></li>
		<li id="menu-item-21372" class="menu-item menu-item-type-post_type menu-item-object-page"><a href="https://www.onepointesolutions.com/lab/laboratory-countertops/phenolic-resin/"><span data-hover="Phenolic Resin">Phenolic Resin</span></a></li>
		<li id="menu-item-20078" class="menu-item menu-item-type-post_type menu-item-object-page"><a href="https://www.onepointesolutions.com/lab/stainless-steel-laboratory-furniture/"><span data-hover="Stainless Steel">Stainless Steel</span></a></li>
	</ul>
</li>
	<li id="menu-item-19890" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children"><a href="https://www.onepointesolutions.com/lab/"><span data-hover="Ventilation and Seating">Ventilation and Seating</span></a>
	<ul class="sub-menu sub-menu-root">
		<li id="menu-item-21498" class="menu-item menu-item-type-post_type menu-item-object-page"><a href="https://www.onepointesolutions.com/lab/fume-hoods/biosafety-cabinets/"><span data-hover="Biosafety Cabinets">Biosafety Cabinets</span></a></li>
		<li id="menu-item-79" class="menu-item menu-item-type-post_type menu-item-object-page"><a href="https://www.onepointesolutions.com/lab/fume-hoods/"><span data-hover="Fume Hoods">Fume Hoods</span></a></li>
		<li id="menu-item-21301" class="menu-item menu-item-type-custom menu-item-object-custom"><a href="https://chairs.onepointesolutions.com"><span data-hover="Lab Chairs and Stools">Lab Chairs and Stools</span></a></li>
	</ul>
</li>
</ul>
</li>
<li id="menu-item-19114" class="mega-menu menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children"><a href="https://www.onepointesolutions.com/laboratory-design/"><span data-hover="Laboratory Design and Construction">Laboratory Design and Construction</span></a>
<ul class="sub-menu sub-menu-root">
	<li id="menu-item-22096" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children"><a href="#"><span data-hover="R&amp;D">R&amp;D</span></a>
	<ul class="sub-menu">
		<li id="menu-item-20134" class="menu-item menu-item-type-post_type menu-item-object-page"><a href="https://www.onepointesolutions.com/animal-research/"><span data-hover="Animal Research">Animal Research</span></a></li>
		<li id="menu-item-18533" class="menu-item menu-item-type-post_type menu-item-object-page"><a href="https://www.onepointesolutions.com/dental-labs/"><span data-hover="Dental Labs">Dental Labs</span></a></li>
		<li id="menu-item-21617" class="menu-item menu-item-type-post_type menu-item-object-page"><a href="https://www.onepointesolutions.com/medical/"><span data-hover="Medical &amp; Clinical Labs">Medical &amp; Clinical Labs</span></a></li>
		<li id="menu-item-18832" class="menu-item menu-item-type-post_type menu-item-object-page"><a href="https://www.onepointesolutions.com/lab/laboratory-tables/academic/"><span data-hover="Academic">Academic</span></a></li>
		<li id="menu-item-22090" class="menu-item menu-item-type-post_type menu-item-object-post"><a href="https://www.onepointesolutions.com/materials-science/"><span data-hover="Material Science">Material Science</span></a></li>
		<li id="menu-item-22095" class="menu-item menu-item-type-post_type menu-item-object-post"><a href="https://www.onepointesolutions.com/volatile-organic-compound-8260/"><span data-hover="Volatile Organic Compound (8260)">Volatile Organic Compound (8260)</span></a></li>
	</ul>
</li>
	<li id="menu-item-22097" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children"><a href="#"><span data-hover="Industry">Industry</span></a>
	<ul class="sub-menu sub-menu-root">
		<li id="menu-item-21361" class="menu-item menu-item-type-post_type menu-item-object-page"><a href="https://www.onepointesolutions.com/cleanroom-design/"><span data-hover="Biopharma &amp; Cleanrooms">Biopharma &amp; Cleanrooms</span></a></li>
		<li id="menu-item-21181" class="menu-item menu-item-type-post_type menu-item-object-page"><a href="https://www.onepointesolutions.com/starting-a-cannabis-lab/"><span data-hover="Cannabis Testing">Cannabis Testing</span></a></li>
		<li id="menu-item-21513" class="menu-item menu-item-type-post_type menu-item-object-page"><a href="https://www.onepointesolutions.com/water-treatment-laboratory/"><span data-hover="Water Treatment (WTP)">Water Treatment (WTP)</span></a></li>
		<li id="menu-item-1806" class="menu-item menu-item-type-custom menu-item-object-custom"><a href="https://www.onepointesolutions.com/food-labs/"><span data-hover="Food Testing">Food Testing</span></a></li>
		<li id="menu-item-22092" class="menu-item menu-item-type-post_type menu-item-object-post"><a href="https://www.onepointesolutions.com/refinery/"><span data-hover="Refinery Labs">Refinery Labs</span></a></li>
		<li id="menu-item-22093" class="menu-item menu-item-type-post_type menu-item-object-post"><a href="https://www.onepointesolutions.com/ag-and-seed/"><span data-hover="Agriculture and Seed Labs">Agriculture and Seed Labs</span></a></li>
		<li id="menu-item-22094" class="menu-item menu-item-type-post_type menu-item-object-post"><a href="https://www.onepointesolutions.com/soil-labs/"><span data-hover="Soil Mechanics &amp; Eng.">Soil Mechanics &amp; Eng.</span></a></li>
		<li id="menu-item-22091" class="menu-item menu-item-type-post_type menu-item-object-post"><a href="https://www.onepointesolutions.com/metallurgy/"><span data-hover="Metallurgy">Metallurgy</span></a></li>
	</ul>
</li>
</ul>
</li>
<li id="menu-item-22561" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children"><a href="#"><span data-hover="Resources">Resources</span></a>
<ul class="sub-menu sub-menu-root">
	<li id="menu-item-21223" class="menu-item menu-item-type-post_type menu-item-object-post"><a href="https://www.onepointesolutions.com/lab-install-why-people-choose-us/"><span data-hover="Installation Services">Installation Services</span></a></li>
	<li id="menu-item-21551" class="menu-item menu-item-type-post_type menu-item-object-page"><a href="https://www.onepointesolutions.com/warranty/"><span data-hover="Our Warranty">Our Warranty</span></a></li>
	<li id="menu-item-20393" class="menu-item menu-item-type-custom menu-item-object-custom"><a href="https://www.onepointesolutions.com/case-studies-3/"><span data-hover="Case Studies">Case Studies</span></a></li>
	<li id="menu-item-20435" class="menu-item menu-item-type-post_type menu-item-object-page"><a href="https://www.onepointesolutions.com/blog/"><span data-hover="Blog">Blog</span></a></li>
	<li id="menu-item-95" class="menu-item menu-item-type-post_type menu-item-object-page"><a href="https://www.onepointesolutions.com/faq/"><span data-hover="FAQ">FAQ</span></a></li>
</ul>
</li>
<li id="menu-item-88" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children"><a href="https://www.onepointesolutions.com/about/"><span data-hover="About">About</span></a>
<ul class="sub-menu sub-menu-root">
	<li id="menu-item-21552" class="menu-item menu-item-type-post_type menu-item-object-page"><a href="https://www.onepointesolutions.com/why-pick-onepointe/"><span data-hover="Why Pick OnePointe">Why Pick OnePointe</span></a></li>
	<li id="menu-item-20839" class="menu-item menu-item-type-custom menu-item-object-custom"><a href="http://onepointesolutions.jobs"><span data-hover="Careers">Careers</span></a></li>
</ul>
</li>
</ul></div>                </nav>
			</div>
		</div>
	</div>
</div>
`
